import React, { FC } from 'react';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import {
  SearchAllContent,
} from '../../../components';

import './style.scss';

const SearchV2: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="SearchV2">
      <Container small>
        <div className="row">
          <SearchAllContent>
            <div className="col-12">
              <h1>{t('search.heading')}</h1>

              {/* Input query */}
              <SearchAllContent.SearchBar />

              {/* Result stats */}
              <SearchAllContent.SearchStats
                translation={(numberOfHits) => `${numberOfHits} ${t('search.results')}`}
              />
            </div>
            <div className="col-12 SearchV2__wrapper" id="SearchV2__wrapper">

              {/* Results */}
              <SearchAllContent.SearchResults />

              {/* Pagination */}
              <SearchAllContent.SearchPagination
                pageRangeDisplayed={3}
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                previousLabel={<a><i className="icon icon-arrow-left" /><span>{t('previous')}</span></a>}
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                nextLabel={<a><span>{t('next')}</span><i className="icon icon-arrow-right" /></a>}
              />
            </div>
          </SearchAllContent>
        </div>
      </Container>
    </div>
  );
};

export default SearchV2;
